import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

import { ListContext } from '@/context/ListContext';



const ContactWidget = () => {

    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.CONTACT} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=Contact&position=${isMainMenu ? 'end' : 'start'}`} />
        </div>
    )
}
export default ContactWidget